import React from "react"
import { Container, Row, Col, Button } from "reactstrap"

import error from "../../assets/images/error-img.png"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { clientCapitalized } from "assets"

const Page404 = () => {
  document.title = `Erro 404 - Página não encontrada | Sensetek ${clientCapitalized}`

  const history = useHistory()

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">
                <h1 className="display-2 fw-medium">
                  4<i className="bx bx-buoy bx-spin text-primary display-3" />4
                </h1>
                <h4 className="text-uppercase">Página não encontrada.</h4>
                {history?.length > 1 && (
                  <div className="mt-5 text-center">
                    <Button
                      className="waves-effect waves-light "
                      color="primary"
                      onClick={() => {
                        history.goBack()
                      }}
                    >
                      Voltar
                    </Button>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" xl="6">
              <div>
                <img src={error} alt="" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Page404
